module.exports = __webpack_public_path__ + "static/media/recurring_acceptance.a0ec634e.svg";